import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'communityCount':
          return Utility.numberFormat(value, 0, true)
        case 'status':
          return Utility.getConstantsLabel(['Status'], value)
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, tenantParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        ['tenant'],
        ['v1TenantDetailGet'],
        [tenantParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited', res[0].data)
            console.log('values', state.values)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    Vue.set(state, 'values', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
